import { useCallback, useEffect, useMemo, useReducer, useRef } from 'react';
import { ValidatorDispatchActionType, validatorReducer, } from './ValidatorReducer';
export function useValidator(fieldIds) {
    const ids = useMemo(() => fieldIds, [fieldIds]);
    const [state, dispatch] = useReducer(validatorReducer, {
        invalidMessages: ids.reduce((acc, id) => (Object.assign(Object.assign({}, acc), { [id]: null })), {}),
        refreshIds: ids.reduce((acc, id) => (Object.assign(Object.assign({}, acc), { [id]: '' })), {}),
    });
    const context = useMemo(() => ({
        validatorState: state,
        validatorDispatch: dispatch,
    }), [state]);
    const validationStarted = useRef(false);
    const validationCompleteFunc = useRef(null);
    const validationIds = useRef(null);
    const validateAll = useCallback((validateIds, onComplete) => {
        validateIds.forEach((id) => dispatch({ type: ValidatorDispatchActionType.TRIGGER_VALIDATION, fieldId: id }));
        validationStarted.current = true;
        validationCompleteFunc.current = onComplete;
        validationIds.current = validateIds;
    }, []);
    const validateAllAsync = useCallback((validateIds) => {
        return new Promise((resolve) => {
            validateAll(validateIds, (errorCount) => {
                resolve(errorCount);
            });
        });
    }, [validateAll]);
    useEffect(() => {
        if (validationStarted.current && !!validationCompleteFunc.current && !!validationIds.current) {
            if (Object.entries(state.refreshIds).every(([key, val]) => { var _a; return val === '' || !((_a = validationIds.current) === null || _a === void 0 ? void 0 : _a.includes(key)); })) {
                // Validation completed, calc number of errors
                const errorsRemaining = Object.entries(state.invalidMessages).filter(([key, val]) => { var _a; return !!val && ((_a = validationIds.current) === null || _a === void 0 ? void 0 : _a.includes(key)); }).length;
                validationCompleteFunc.current(errorsRemaining, state);
                validationStarted.current = false;
                validationCompleteFunc.current = null;
                validationIds.current = null;
            }
        }
    }, [state]);
    return { state, dispatch, context, validateAll, validateAllAsync };
}
